import httpClient from "../config/httpClient";
import { IPatchApartmentWhiteList, IPostDataApartmentWhiteList } from "../models/retail/apartments.model";
import { DropdownOptionDto } from "../models/common.model";

export abstract class DataService {
	private static readonly DROPDOWN_URL = "/sys03/data/dropdown";

	public static findDropdownData({ name, sortType }: { name: string; sortType?: "default" | "number" }): Promise<DropdownOptionDto[]> {
		const url = `${DataService.DROPDOWN_URL}/${name}`;
		return httpClient.get<DropdownOptionDto[]>(url).then((response) => {
			const data = response.data;

			if (data && Array.isArray(data)) {
				if (sortType === "number") {
					return data.sort((a, b) => {
						const aValue = Number(a.value);
						const bValue = Number(b.value);

						return aValue - bValue;
					});
				}

				return data.sort((a, b) => {
					const aDisplayName = a.displayName.toLowerCase();
					const bDisplayName = b.displayName.toLowerCase();
					if (aDisplayName < bDisplayName) return -1;
					if (aDisplayName > bDisplayName) return 1;
					return 0;
				});
			}

			return data ?? [];
		});
	}

	public static getDropdowns() {
		const url = `/admin/data/dropdown`;
		return httpClient.get(url);
	}

	public static createDropdown(data: any) {
		const url = `/admin/data/dropdown`;
		return httpClient.post(url, data);
	}

	public static patchDropdown(id: number, data: any) {
		const url = `/admin/data/dropdown/${id}`;
		return httpClient.patch(url, data);
	}

	public static getDropdownData(id: number) {
		const url = `/admin/data/dropdown/${id}/data`;
		return httpClient.get(url);
	}

	public static createDropdownData(data: any) {
		const url = `/admin/data/dropdown/data`;
		return httpClient.post(url, data);
	}

	public static patchDropdownData(id: number, data: any) {
		const url = `/admin/data/dropdown/data/${id}`;
		return httpClient.patch(url, data);
	}

	public static getApartmentsWhiteList() {
		const url = `/sys03/apartments-whitelist?limit=50&used=false`;
		return httpClient.get(url);
	}

	public static postApartmentsWhiteList(data: IPostDataApartmentWhiteList) {
		const url = `/sys03/apartments-whitelist`;
		return httpClient.post(url, data);
	}

	public static patchApartmentsWhiteList({ id, data }: IPatchApartmentWhiteList) {
		const url = `/sys03/apartments-whitelist/${id}`;
		return httpClient.patch(url, data);
	}
}
